import React from 'react'
import Select, { Styles } from 'react-select'

import './TokenSelector.scss'

const customStyles: Styles<any, any> = {
  control: (provided, state) => ({
    ...provided,
    border: 0
  }),
  placeholder: (provided, state) => ({
    ...provided,
    color: '#000',
    fontWeight: 500
  })
}

export const TokenSelector: React.FC<{
  onChange: (v: { label: JSX.Element; value: string }) => void
  selected: { label: JSX.Element; value: string } | undefined
  options: { label: JSX.Element; value: string }[]
}> = ({ onChange, selected, options }) => {
  return (
    <Select
      className="TokenSelector"
      classNamePrefix="TokenSelector"
      styles={customStyles}
      options={options}
      onChange={onChange as any}
      value={selected}
    />
  )
}
